import touchevents from 'modernizr-esm/feature/touchevents'
import webpAlpha from 'modernizr-esm/feature/img/webp-alpha'
import webpAnimation from 'modernizr-esm/feature/img/webp-animation'
import webpLossless from 'modernizr-esm/feature/img/webp-lossless'
import webworkers from 'modernizr-esm/feature/workers/webworkers'
import transferables from 'modernizr-esm/feature/workers/transferables'
import adownload from 'modernizr-esm/feature/a/download'
import bloburls from 'modernizr-esm/feature/url/bloburls'
import blobconstructor from 'modernizr-esm/feature/blob'

import { reactive, toRefs } from 'vue'

const volumeTest = document.createElement('audio')
volumeTest.volume = 0.5

const result = reactive({
  volume: volumeTest.volume === 0.5,
  adownload,
  webworkers,
  blobconstructor,
  bloburls,
  touchevents
})

const runAsyncTests = async () => {
  result['webp-alpha'] = result.webp = await webpAlpha()
  result['webp-animation'] = await webpAnimation()
  result['webp-lossless'] = await webpLossless()
  result.transferables = await transferables()
}
runAsyncTests()
/**
 *
 * @returns
 */
export const useModernizr = () => {
  // use toRefs in order to allow destructuring of this object
  // and retain reactivity
  // https://v3.vuejs.org/guide/reactivity-fundamentals.html#destructuring-reactive-state
  return toRefs(result)
}

export default useModernizr
